import {AavoDialog, AavoDialogProps} from "src/components/common/dialogs/AavoDialog";
import i18n from "i18next";
import {AavoButton} from "src/components/common/buttons/AavoButton";

export interface ConfirmDialogProps extends Omit<AavoDialogProps, "title" | "actions" | "size"> {
	title?: string;
	onConfirm: () => void;
	onCancel?: () => void;
}

export const ConfirmDialog = ({
	title,
	onConfirm,
	onCancel,
	onClose,
	...other
}: ConfirmDialogProps) => {
	return (
		<AavoDialog
			size={"sm"}
			title={title || i18n.t("are_you_sure")}
			actions={
				<>
					<AavoButton
						color={"secondary"}
						onClick={(e) => {
							e.preventDefault();
							if (onCancel) {
								onCancel();
							} else if (onClose) {
								onClose("escapeKeyDown");
							}
						}}
					>
						{i18n.t("cancel")}
					</AavoButton>
					<AavoButton
						onClick={(e) => {
							e.preventDefault();
							onConfirm();
						}}
					>
						{i18n.t("ok")}
					</AavoButton>
				</>
			}
			onClose={onClose}
			{...other}
		/>
	);
};
